import {checkAddress, checkEmail, checkTaxCode} from "./RegexUtils";

export const passwordRegister = {
	required: "Di ciula!La password boia faus! :P",
	pattern: {
		value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
		message: "La password non rispetta i requisiti richiesti",
	},
	minLength: {
		value: 8,
		message: "La passowrd non rispetta la lunghezza minima di 8 caratteri"
	},
	maxLength: {
		value: 16,
		message: "La passowrd non rispetta la lunghezza massima di 16 caratteri"
	}
}

export const codFRegister = {
	required: "Questo campo è obbligatorio",
	validate: (value) => {
		return checkTaxCode(value, false)
	},
	minLength: {
		value: 16,
		message: "Il codice fiscale non rispetta la lunghezza minima di 16 caratteri"
	},
	maxLength: {
		value: 16,
		message: "Il codice fiscale non rispetta la lunghezza massima di 16 caratteri"
	}
}

export const codFRegisterLogin = {
	required: true,
	validate: (value) => {
		return checkTaxCode(value, false)
	},
	minLength: {
		value: 16,
		message: "valore non corretto"
	},
	maxLength: {
		value: 16,
		message: "valore non corretto"
	}
}

export const companyUsername = {
	required: true,
	pattern: {
		value: /^((((CMPU|CMPR)_[0-9]+)|((CMPU|CMPR)_[0-9]+_[0-9]+))|(POSEIDON)|(poseidon)|(cap)|(CAP)|(ironman)|(IRONMAN)|(hulk)|(HULK)|(falcon)|(FALCON)|(wintersoldier)|(WINTERSOLDIER)|(gamora)|(GAMORA)|(spiderman)|(SPIDERMAN)|(drax)|(DRAX)|(thor)|(THOR)|(antman)|(ANTMAN)|(wasp)|(WASP)|(blackpanther)|(BLACKPANTER)|(capitanmarvel)|(CAPITANMARVEL)|(occhiodifalco)|(OCCHIODIFALCO)|(vedovanera)|(VEDOVANERA)|(warmachine)|(WARMACHINE)|(mariahill)|(MARIAHILL)|(groot)|(GROOT)|(rocket)|(ROCKET)|(starlord)|(STARLORD)|(doctorstrange)|(DOCTORSTRANGE)|(mantis)|(MANTIS)|(visione)|(VISIONE)|(wanda)|(WANDA))$/,
		message: "valore non corretto",
	},
	minLength: {
		value: 2,
		message: "valore non corretto"
	},
	maxLength: {
		value: 30,
		message: "valore non corretto"
	}
}

export const codFRegisterNone = {
	required: false,
	minLength: {
		value: 16,
		message: "Il codice fiscale non rispetta la lunghezza minima di 16 caratteri"
	},
	maxLength: {
		value: 16,
		message: "Il codice fiscale non rispetta la lunghezza massima di 16 caratteri"
	}
}

export const phoneRegister = {
	required: "Questo campo è obbligatorio",
	pattern: {
		value: /^\d+/,
		message: "Il telefono deve contenere solo numeri",
	},
	minLength: {
		value: 7,
		message: "Il telefono non rispetta la lunghezza minima di 7 caratteri"
	},
	maxLength: {
		value: 14,
		message: "Il telefono non rispetta la lunghezza massima di 14 caratteri"
	}
}

export const phoneRegisterPrivate = {
	required: false,
	pattern: {
		value: /^\d+/,
		message: "Il telefono deve contenere solo numeri",
	},
	minLength: {
		value: 7,
		message: "Il telefono non rispetta la lunghezza minima"
	},
	maxLength: {
		value: 14,
		message: "Il telefono non rispetta la lunghezza massima"
	}
}

export const bigNoteRegisterRequired = {
	required: "Hey, inserisci qualcosa nel messaggio!",
	minLength: {
		value: 2,
		message: "Inserisci qualcosa che sia utile, meno di due caratteri sono un po' pochi :)"
	},
	maxLength: {
		value: 8190,
		message: "Hai davvero scritto tutto questo? Ok, però qui abbrevia che non ci sta nel DB :)"
	}
}

export const bigNoteRegisterRequired1000 = {
	required: "Hey, inserisci qualcosa nel messaggio!",
	minLength: {
		value: 10,
		message: "Inserisci qualcosa che sia utile, meno di due caratteri sono un po' pochi :)"
	},
	maxLength: {
		value: 1000,
		message: "Hai davvero scritto tutto questo? Ok, però qui abbrevia che non ci sta nel DB :)"
	}
}

export const bigNoteRegisterNotRequired = {
	required: false,
	minLength: {
		value: 2,
		message: "Inserisci qualcosa che sia utile, meno di due caratteri sono un po' pochi :)"
	},
	maxLength: {
		value: 8190,
		message: "Hai davvero scritto tutto questo? Ok, però qui abbrevia che non ci sta nel DB :)"
	}
}

export const sollecitoRegister = {
	required: "Se vuoi sollecitare, inserisci un motivo!",
	minLength: {
		value: 2,
		message: "Inserisci qualcosa che sia utile, meno di due caratteri sono un po' pochi :)"
	},
	maxLength: {
		value: 900,
		message: "Hai davvero scritto tutto questo? Ok, però qui abbrevia che non ci sta nel DB :)"
	}
}

export const nomeRegister = {
	required: "Questo campo è obbligatorio",
	pattern: {
		value: /^([a-zA-Z]|[òàùèéçì']|\s){2,200}$/,
		message: "Il nome deve contenere solo caratteri",
	},
	minLength: {
		value: 2,
		message: "Il nome non rispetta la lunghezza minima di 2 caratteri"
	},
	maxLength: {
		value: 200,
		message: "Il nome non rispetta la lunghezza massima di 200 caratteri"
	}
}

export const cognomeRegister = {
	required: "Questo campo è obbligatorio",
	pattern: {
		value: /^([a-zA-Z]|ò|à|ù|è|é|ç|ì|\s|'){2,200}$/,
		message: "Il cognome deve contenere solo caratteri",
	},
	minLength: {
		value: 2,
		message: "Il cognome non rispetta la lunghezza minima di 2 caratteri"
	},
	maxLength: {
		value: 200,
		message: "Il cognome non rispetta la lunghezza massima di 200 caratteri"
	}
}

export const nomeRegisterNone = {
	required: false,
	pattern: {
		value: /^([a-zA-Z]|[òàùèéçì']|\s){2,200}$/,
		message: "Il nome deve contenere solo caratteri",
	},
	minLength: {
		value: 2,
		message: "Il nome non rispetta la lunghezza minima di 2 caratteri"
	},
	maxLength: {
		value: 200,
		message: "Il nome non rispetta la lunghezza massima di 200 caratteri"
	}
}

export const cognomeRegisterNone = {
	required: false,
	pattern: {
		value: /^([a-zA-Z]|ò|à|ù|è|é|ç|ì|\s|'){2,200}$/,
		message: "Il cognome deve contenere solo caratteri",
	},
	minLength: {
		value: 2,
		message: "Il cognome non rispetta la lunghezza minima di 2 caratteri"
	},
	maxLength: {
		value: 200,
		message: "Il cognome non rispetta la lunghezza massima di 200 caratteri"
	}
}

export const emailRegister = {
	required: "Questo campo è obbligatorio",
	validate: (value) => {
		return checkEmail(value)
	},
	minLength: {
		value: 5,
		message: "L'email non rispetta la lunghezza minima di 5 caratteri"
	},
	maxLength: {
		value: 60,
		message: "L'email non rispetta la lunghezza massima di 60 caratteri"
	}
}

export const addressRegister = {
	required: "Questo campo è obbligatorio",
	validate: (value) => {
		return checkAddress(value)
	},
	minLength: {
		value: 5,
		message: "L'indirizzo non rispetta la lunghezza minima di 2 caratteri"
	},
	maxLength: {
		value: 50,
		message: "L'indirizzo non rispetta la lunghezza massima di 40 caratteri"
	}
}

export const emailRegisterNone = {
	required: false,
	validate: (value) => {
		return checkEmail(value)
	},
	minLength: {
		value: 5,
		message: "L'email non rispetta la lunghezza minima di 5 caratteri"
	},
	maxLength: {
		value: 50,
		message: "L'email non rispetta la lunghezza massima di 50 caratteri"
	}
}

export const addressRegisterNone = {
	required: false,
	validate: (value) => {
		return checkAddress(value)
	},
	minLength: {
		value: 4,
		message: "L'indirizzo non rispetta la lunghezza minima"
	},
	maxLength: {
		value: 50,
		message: "L'indirizzo non rispetta la lunghezza massima"
	}
}

export const valueRegister = {
	required: true,
	minLength: {
		value: 4,
		message: "Il valore non rispetta la lunghezza minima"
	},
	maxLength: {
		value: 255,
		message: "Il valore non rispetta la lunghezza massima"
	}
}

export const numberRegister = {
	required: "Questo campo è obbligatorio",
	pattern: {
		value: /^([0-9]|.)+$/,
		message: "Il valore non è valido",
	},
}

export const numberRegisterNone = {
	required: false,
	pattern: {
		value: /^([0-9]|.)+$/,
		message: "Il valore non è valido",
	},
}

export const valueRegisterNone = {
	required: false,
	minLength: {
		value: 4,
		message: "Il valore non rispetta la lunghezza minima"
	},
	maxLength: {
		value: 255,
		message: "Il valore non rispetta la lunghezza massima"
	}
}

export const scuolaRegister = {
	required: "Questo campo è obbligatorio",
}

export const autocompleteRules = {
	required: true,
	validate: (value) => {
		if (!value) return false
		return value.length > 0
	},
}

export const autocompleteRulesNotReq = {
	required: false,
}

export const questionRequired = {
	required: "Hey, inserisci qualcosa nella domanda!",
	minLength: {
		value: 5,
		message: "Inserisci qualcosa che sia utile, meno di 5 caratteri sono un po' pochi :)"
	},
	maxLength: {
		value: 250,
		message: "Hai davvero scritto tutto questo? Ok, però qui abbrevia che non ci sta nel DB :)"
	}
}
